import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { getProductByIdQuery, getCategoriesQuery } from "../../queries";
import Loader from "../../Components/Common/Loader";
import settings from "../../settings/settings";

import BreadCrumb from "../../Components/Common/BreadCrumb";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import SwiperCore from "swiper";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

function ProductDetail(props) {
  const { id } = useParams();
  const { t } = useTranslation();
  document.title = t("Product Details") + " | Bozor Admin";

  const { data: productData, isLoading } = useQuery({
    ...getProductByIdQuery(id),
  });

  const { data: categoriesData } = useQuery({
    ...getCategoriesQuery({ isAll: true }),
  });

  const product = productData?.data?.data;
  const categories = categoriesData?.data?.data || [];
  const category = categories.find(c => c.id === product?.categoryId);
  const categoryName = category?.locales?.find(l => l.localeKey === 'ru')?.name || category?.locales?.[0]?.name || t("Unknown");

  if (isLoading) return <Loader />;

  if (!product) return <div>Product not found</div>;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={t("Product Details")} pageTitle={t("Ecommerce")} />

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  <Col xl={4} md={8} className="mx-auto">
                    <div className="product-img-slider sticky-side-div">
                      <div className="bg-light rounded p-2">
                        <img
                          src={product.imageId ? `${settings.catalogBaseURL}/products/images/${product.imageId}` : "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"}
                          alt=""
                          className="img-fluid d-block"
                        />
                      </div>
                    </div>
                  </Col>

                  <Col xl={8}>
                    <div className="mt-xl-0 mt-5">
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="flex-grow-1">
                          <h4 className="fw-bold fs-2 mb-3">
                            {product.locales?.find(l => l.localeKey === 'ru')?.name || product.locales?.[0]?.name || t("Unknown Product")}
                          </h4>
                        </div>
                        <div className="flex-shrink-0">
                          <Link
                            to={`/products/edit/${product.id}`}
                            className="btn btn-primary btn-label waves-effect waves-light"
                          >
                            <i className="ri-pencil-fill label-icon align-middle fs-16 me-2"></i> {t("Edit")}
                          </Link>
                        </div>
                      </div>

                      <div className="product-content mt-2">
                        <h5 className="fs-15 mb-3 fw-semibold text-uppercase text-muted">{t("Product Description:")}</h5>

                        <div className="card shadow-none border">
                          <CardBody>
                            <div className="d-flex flex-column gap-3">
                              <div className="d-flex justify-content-between border-bottom pb-2">
                                <div className="d-flex align-items-center gap-2 text-muted max-w-50">
                                  <i className="ri-price-tag-3-line fs-18"></i>
                                  <span>{t("Category")}</span>
                                </div>
                                <div className="fw-medium">{categoryName}</div>
                              </div>
                              <div className="d-flex justify-content-between border-bottom pb-2">
                                <div className="d-flex align-items-center gap-2 text-muted">
                                  <i className="ri-ruler-2-line fs-18"></i>
                                  <span>{t("Unit of Measure")}</span>
                                </div>
                                <div className="fw-medium text-capitalize">{product.unitOfMeasure}</div>
                              </div>
                              <div className="d-flex justify-content-between border-bottom pb-2">
                                <div className="d-flex align-items-center gap-2 text-muted">
                                  <i className="ri-qr-code-line fs-18"></i>
                                  <span>{t("Product Code")}</span>
                                </div>
                                <div className="fw-medium font-monospace">{product.productCode || "-"}</div>
                              </div>
                              <div className="d-flex justify-content-between border-bottom pb-2">
                                <div className="d-flex align-items-center gap-2 text-muted">
                                  <i className="ri-archive-line fs-18"></i>
                                  <span>{t("Package Code")}</span>
                                </div>
                                <div className="fw-medium font-monospace">{product.packageCode || "-"}</div>
                              </div>
                              <div className="d-flex justify-content-between">
                                <div className="d-flex align-items-center gap-2 text-muted">
                                  <i className="ri-barcode-box-line fs-18"></i>
                                  <span>{t("Barcode")}</span>
                                </div>
                                <div className="fw-medium font-monospace">{product.barcode || "-"}</div>
                              </div>
                            </div>
                          </CardBody>
                        </div>

                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div >
  );
}


export default ProductDetail;